import React from "react";

// Convierte texto plano de la DB en bloques con formato legible:
//  - Una o más líneas vacías (\n\n) => separa párrafos <p> con margen
//  - Un solo \n dentro de un párrafo => salto de línea <br>
//  - **texto** => <strong>texto</strong> (negrita)
//
// El contenido se renderiza como nodos React (texto escapado automáticamente),
// por lo que NO hay riesgo de XSS aunque la descripción contenga <script> etc.
export function formatRichText(text: string | undefined | null): React.ReactNode {
  if (!text) return null;

  // 1. Separar en párrafos por líneas vacías
  const paragraphs = text.replace(/\r\n/g, "\n").split(/\n\s*\n/);

  return paragraphs.map((para, i) => {
    const lines = para.split("\n");
    const nodes: React.ReactNode[] = [];
    lines.forEach((line, j) => {
      if (j > 0) nodes.push(<br key={`br-${i}-${j}`} />);
      nodes.push(renderInline(line, `${i}-${j}`));
    });
    return (
      <p key={`p-${i}`} style={{ margin: "0 0 10px 0", lineHeight: 1.5 }}>
        {nodes}
      </p>
    );
  });
}

// Reemplaza **texto** por <strong> sin usar dangerouslySetInnerHTML.
// split con grupo captor: los índices impares son el texto a poner en negrita.
function renderInline(line: string, keyPrefix: string): React.ReactNode {
  const parts = line.split(/\*\*(.+?)\*\*/g);
  return parts.map((part, k) => {
    if (k % 2 === 1) {
      return <strong key={`b-${keyPrefix}-${k}`}>{part}</strong>;
    }
    return <React.Fragment key={`t-${keyPrefix}-${k}`}>{part}</React.Fragment>;
  });
}
